<template>
  <div class="w-full" style="z-index: 5000">
    <vs-select autocomplete class="selectExample w-full" v-model="answer" @change="$emit('input', answer)">
      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
    </vs-select>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      answer: this.value,
      options: [
        { value: true, text: "(Boolean) es verdadero" },
        { value: false, text: "(Boolean) es falso" }
      ]
    };
  }
};
</script>

<style lang="scss">
.vs-select--options {
  z-index: 2000000;
}
#Compound {
  .input-select {
    background-color: transparent;
    border: none;
  }
}
</style>
